export default function () {
    var isTouchScreen = false;
    var submenuTrigger = 'click';
    var body = document.getElementsByTagName('BODY')[0];

    // Check device
    (function () {
        if ('ontouchstart' in document.documentElement) {
            isTouchScreen = true;
        }
    })();

    // Get viewport
    function viewport() {
        var viewportwidth;
        if (typeof window.innerWidth !== 'undefined') {
            viewportwidth = window.innerWidth;
        } else if (typeof document.documentElement !== 'undefined' && typeof document.documentElement.clientWidth !== 'undefined' && document.documentElement.clientWidth !== 0) {
            viewportwidth = document.documentElement.clientWidth;
        } else {
            viewportwidth = body.clientWidth;
        }
        return viewportwidth;
    }

    // Set correct clicktrigger (only on desktop menu (1200+) when touchscreen)
    if (viewport() >= 1200) {
        if (isTouchScreen) {
            submenuTrigger = 'dblclick';
        }
    }

    function removeActiveItem() {
        const activeSubmenus = document.querySelector('.nav-item.dropdown.clicked');
        if (activeSubmenus) {
            activeSubmenus.classList.remove('clicked');
        }
    }

    if (submenuTrigger === 'dblclick') {
        const submenutoggles = document.querySelectorAll('.nav-item.dropdown > .nav-link.dropdown-toggle');
        if (submenutoggles.length > 0) {
            document.addEventListener('click', function (event) {
                if (!event.target.matches('.nav-link.dropdown-toggle')) {
                    removeActiveItem();
                }
            });

            submenutoggles.forEach(function (element) {
                element.addEventListener('click', function (event) {
                    event.preventDefault();
                    const parentEl = this.parentElement;

                    if (parentEl.classList.contains('clicked')) {
                        window.location.href = element.href;
                    }
                    else {
                        removeActiveItem();
                        parentEl.classList.add('clicked');
                    }
                });
            });
        }
    }
};
